import React, { useState } from "react";
import { Instagram, Youtube, Twitter } from "lucide-react";
import { ReturnPolicy } from "./ReturnPolicy";
import { Careers } from "./Careers";

export const Footer = () => {
  const [policyOpen, setPolicyOpen] = useState(false);
  const [careersOpen, setCareersOpen] = useState(false);

  return (
    <footer data-testid="site-footer" className="bg-background border-t border-border">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-14">
        <div className="grid md:grid-cols-4 gap-10">
          <div className="md:col-span-2">
            <div className="flex items-center gap-3">
              <span className="relative w-12 h-12 rounded-full overflow-hidden ring-2 ring-accent/40 shrink-0">
                <img
                  src="https://customer-assets-lqy194kg.emergentagent.net/job_alternate-you-83/artifacts/i0gmlqe6_VILLAGEFARMFOOD%20LOGO.jpg"
                  alt="Village Farm Food logo"
                  className="w-full h-full object-cover"
                />
              </span>
              <div className="font-display text-3xl font-semibold leading-tight">
                Village<span className="text-accent">·</span>Farm<span className="text-accent">·</span>Food
              </div>
            </div>
            <div className="mt-3 font-mono-ui text-[11px] uppercase tracking-[0.25em] text-accent">
              Direct to Farm · Shuddh &amp; Swadeshi
            </div>
            <p className="mt-4 text-sm text-muted-foreground max-w-xs leading-relaxed">
              Pressed slow. Grown honest. Delivered fresh. A small pantry that
              works with 26 farms across Rajasthan and beyond.
            </p>
          </div>
          <div>
            <div className="font-mono-ui text-xs uppercase tracking-widest text-muted-foreground mb-4">
              Shop
            </div>
            <ul className="space-y-2 text-sm">
              <li><a href="#shop" className="hover:text-accent" data-testid="footer-cat-ghee">Ghee</a></li>
              <li><a href="#shop" className="hover:text-accent" data-testid="footer-cat-milk">Milk</a></li>
              <li><a href="#shop" className="hover:text-accent" data-testid="footer-cat-makhan">Makhan</a></li>
              <li><a href="#shop" className="hover:text-accent" data-testid="footer-cat-oil">Oil</a></li>
              <li><a href="#shop" className="hover:text-accent" data-testid="footer-cat-vegetables">Vegetables</a></li>
              <li><a href="#shop" className="hover:text-accent" data-testid="footer-cat-mushroom">Mushroom</a></li>
              <li><a href="#shop" className="hover:text-accent" data-testid="footer-cat-spices">Spices</a></li>
              <li><a href="#shop" className="hover:text-accent" data-testid="footer-cat-seeds">Seeds</a></li>
              <li><a href="#shop" className="hover:text-accent" data-testid="footer-cat-aata">Aata</a></li>
              <li><a href="#shop" className="hover:text-accent" data-testid="footer-cat-dryfruits">Dry Fruits</a></li>
              <li><a href="#shop" className="hover:text-accent" data-testid="footer-cat-coconut">Coconut</a></li>
              <li><a href="#shop" className="hover:text-accent" data-testid="footer-cat-aachar">Aachar</a></li>
              <li><a href="#shop" className="hover:text-accent" data-testid="footer-cat-tea">Tea</a></li>
              <li><a href="#shop" className="hover:text-accent" data-testid="footer-cat-rajasthani">Rajasthani Dry Veg</a></li>
              <li><a href="#shop" className="hover:text-accent" data-testid="footer-cat-laddu">Laddu</a></li>
            </ul>
          </div>
          <div>
            <div className="font-mono-ui text-xs uppercase tracking-widest text-muted-foreground mb-4">
              Company
            </div>
            <ul className="space-y-2 text-sm">
              <li><a href="#wallet" className="hover:text-accent" data-testid="footer-wallet">Pantry Wallet</a></li>
              <li><a href="#reservations" className="hover:text-accent" data-testid="footer-reserve">Bulk Orders</a></li>
              <li><a href="#contact" className="hover:text-accent" data-testid="footer-contact">Contact</a></li>
              <li>
                <button
                  data-testid="footer-careers"
                  onClick={() => setCareersOpen(true)}
                  className="hover:text-accent text-left"
                >
                  Careers
                </button>
              </li>
              <li>
                <button
                  data-testid="footer-return-policy"
                  onClick={() => setPolicyOpen(true)}
                  className="hover:text-accent text-left"
                >
                  Return &amp; Refund Policy
                </button>
              </li>
              <li>
                <a
                  href="/admin/login"
                  data-testid="footer-admin"
                  className="hover:text-accent"
                >
                  Admin
                </a>
              </li>
              <li>
                <a
                  href="/agent/login"
                  data-testid="footer-agent"
                  className="hover:text-accent"
                >
                  Agent
                </a>
              </li>
            </ul>

            <div className="mt-6 font-mono-ui text-xs uppercase tracking-widest text-muted-foreground mb-3">
              Follow
            </div>
            <div className="flex gap-3">
              <a href="#" className="w-9 h-9 rounded-full border border-border flex items-center justify-center hover:bg-accent hover:text-accent-foreground hover:border-accent transition-colors" aria-label="Instagram"><Instagram className="w-4 h-4" /></a>
              <a href="#" className="w-9 h-9 rounded-full border border-border flex items-center justify-center hover:bg-accent hover:text-accent-foreground hover:border-accent transition-colors" aria-label="YouTube"><Youtube className="w-4 h-4" /></a>
              <a href="#" className="w-9 h-9 rounded-full border border-border flex items-center justify-center hover:bg-accent hover:text-accent-foreground hover:border-accent transition-colors" aria-label="Twitter"><Twitter className="w-4 h-4" /></a>
            </div>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-border flex flex-col md:flex-row items-center justify-between gap-3 text-xs font-mono-ui text-muted-foreground uppercase tracking-widest">
          <div>© 2026 Village Farm Food · Malkash, Bhadra · Rajasthan 335501 · +91 93973 63140</div>
          <div>Batch 026 · pressed with care</div>
        </div>
      </div>

      <ReturnPolicy open={policyOpen} onClose={setPolicyOpen} />
      <Careers open={careersOpen} onClose={setCareersOpen} />
    </footer>
  );
};
